<template>

    <div class="cc-4-l widget-simple-text cc-bg-green" :class="boxKlass">

        <!-- If loading -->
        <div class="cc-loader " v-if="loading">
            <div class="spinner"></div>
        </div>

        <!-- else -->
        <div v-else>
            <div v-if="!errored">
                <p class="cc-fs-75">
                    <i class="fal fa-tachometer icon-left" aria-hidden></i>
                    {{ score }} {{ suffix }}
                </p>
            </div>
            <div v-else>
                <i class="fas fa-spider-black-widow icon-left" aria-hidden></i>
                LightHouse down ?
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    const api = 'https://www.googleapis.com/pagespeedonline/v5/runPagespeed?url=__##__&filter_third_party_resources=false&locale=fr_FR&screenshot=false&snapshots=false&strategy=mobile&key=AIzaSyAD5npoUNrPbrVJYJA2Ftf6J2MczptiY44'

    export default {
        name: 'GoogleInsight',
        data() {
            return {
                website: 'https://www.alpixel.fr',
                finalApi: null,
                boxKlass: '',
                score: 0,
                errored: false,
                loading: true,
                suffix: ' / 100'
            }
        },
        computed: {
            getDomain: function () {
                return this.website.substring(8)
            }

        },
        mounted() {

            // Set final Api with website
            this.finalApi = api.replace('__##__', encodeURI(this.website));

            // Get Google Insight score
            axios
                .get(this.finalApi)
                .then(response => {
                    this.score = parseInt(response.data.lighthouseResult.categories.performance.score * 100)
                    if (this.score >= 85)
                        this.boxKlass = 'cc-bg-green'
                    else if (this.score >= 50)
                        this.boxKlass = 'cc-bg-orange'
                    else
                        this.boxKlass = 'cc-bg-red'
                })
                .catch(error => {
                    console.log(error)
                    this.errored = true
                    this.boxKlass = 'cc-bg-red'
                })
                .finally(() => {
                    this.loading = false
                })
        },
    }
</script>


<style scoped lang="less">
</style>
